/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceTag
 */
export interface SourceTag {
    /**
     * 
     * @type {string}
     * @memberof SourceTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SourceTag
     */
    name: string;
}

/**
 * Check if a given object implements the SourceTag interface.
 */
export function instanceOfSourceTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SourceTagFromJSON(json: any): SourceTag {
    return SourceTagFromJSONTyped(json, false);
}

export function SourceTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SourceTagToJSON(value?: SourceTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

